// @flow
export const getAssetsUrl = (path: string): string =>
  process.env.SERVER === 'production'
    ? `https://assets.prohabits.com/${path}`
    : `https://assets.dev.prohabits.com/${path}`
